<template>
    <div class="statusvideo">        
        
        
        <div class="status_and_info">
            <span
                @click="testUpdate"
                class="statusvideo_text"
                :class="status.color"
                :title="statusHint || undefined"
            >
                {{status.status ? status.status : 'Not analyzed'}}
            </span>
            <span
                v-show="progressText"
                class="text-grey statusvideo_progress"
                style="margin-left:6px;font-size:12px;"
            >
                {{ progressText }}
            </span>
            <span class="text-grey statusvideo_presons">
                <span 
                    v-show="status.status == 'WRONG' && wrongReason"
                    class="statusvideo_presons_text statusvideo_wrong_reason"
                    :title="wrongReason"
                >
                    {{ wrongReasonShort }}
                </span>
                <span 
                    v-show="status.status == 'WRONG' && !wrongReason"
                    class="statusvideo_presons_text"
                >
                    Unknown
                </span>
                <div 
                    v-show="showPersonsSpinner" 
                    class="spinner-border spinner-border-sm text-primary statusvideo_report_spinner"
                    role="status"
                    title="Preparing report…"
                >
                  <span class="visually-hidden">Загрузка...</span>
                </div>

                <span
                    v-show="showNoReport"
                    class="statusvideo_presons_text statusvideo_no_report"
                    title="No report"
                >
                    No Report
                </span>
                
                <a 
                    v-show="showPersonsLink"
                    :href="resolvedReportLink || defreportlink_data"
                    class="statusvideo_presons_link"
                >
                    {{personsnum_data}} persons
                </a>
                
            </span>
        </div>


        <span class="statusvideo_buttons">           
            <button 
                v-show="status.status == undefined"  
                @click="analizeSend('analize')" 
                class="btn btn-border btn-sm table-list-row__action"
            >
                ANALYZE
            </button>
            <button 
                v-show="status.status == 'DONE' || status.status == 'WRONG'"  
                @click="analizeSend('reanalize')" 
                class="btn btn-border btn-sm table-list-row__action"
            >
                REANALYZE
            </button>
            <button 
                v-show="status.status == 'PROC' || status.status == 'WAIT'" 
                @click="changeStatus(3)" 
                class="btn btn-border-light btn-sm table-list-row__action"
            >
                STOP
            </button>
           <button 
                v-show="status.status == 'STOP'"
                @click="changeStatus(2)" 
                class="btn btn-border btn-sm table-list-row__action"
            >
                CONTINUE
            </button>
        </span>
    </div>
</template>

<script>
import axios from "axios";
import {bus} from "../bus";

export default {
    props: [
        'v_id', 
        'status_prop',         
        'statuses',
        'personsnum',
        'defreportlink',
        'lastreportid',
        'description_prop'
    ],
    data(){
        return{
            status: { id: null, status: null, created_at: null, updated_at: null, color: null },
            persons: [],
            waitReport: false,
            reportPollTries: 0,
            // True only after post-DONE wait confirmed a durable empty report (0 persons).
            emptyReportConfirmed: false,
            personsnum_data: '',
            defreportlink_data: '',
            percent_analys: null,
            processed_frames: null,
            count_frames: null,
            wrongReason: '',
            // REANALYZE/ANALYZE in flight: ignore stale SDK/list DONE until wait|proc.
            inflightAnalyze: false,
            statusPollToken: 0,
            inflightStaleDoneTries: 0,
        }
    },
    computed: {
        wrongReasonShort() {
            const t = (this.wrongReason || '').trim();
            if (!t) return '';
            return t.length > 48 ? t.slice(0, 45) + '…' : t;
        },
        statusHint() {
            const st = (this.status && this.status.status) || '';
            if (st === 'WRONG' && this.wrongReason) return this.wrongReason;
            return '';
        },
        resolvedReportLink() {
            const link = (this.defreportlink_data || '').trim();
            if (link && link !== '#' && !link.endsWith('/reports/') && /\/reports\/\d+/.test(link)) {
                return link;
            }
            // While waiting for mint, ignore stale lastreportid from a previous run.
            if (this.waitReport) {
                return '';
            }
            if (this.lastreportid) {
                return `/reports/${this.lastreportid}`;
            }
            return '';
        },
        reportReady() {
            const n = Number(this.personsnum_data);
            if (!this.resolvedReportLink || !Number.isFinite(n)) {
                return false;
            }
            // Populated report — show "N persons" link.
            if (n > 0) {
                return true;
            }
            // Truly empty video result only after wait confirmed (not the mid-mint "0" flash).
            return this.emptyReportConfirmed && n === 0;
        },
        showPersonsSpinner() {
            const st = (this.status && this.status.status) || '';
            // Mid-analyze: spinner is OK next to WAIT/PROC (not next to DONE).
            if (st === 'PROC' || st === 'WAIT') return true;
            // Never show DONE + spinner from a stale reanalyze race.
            if (this.inflightAnalyze) return false;
            // True post-DONE mint only.
            if (st === 'DONE' && this.waitReport) return true;
            return false;
        },
        showNoReport() {
            const st = (this.status && this.status.status) || '';
            // DONE + no durable report (deleted / never minted) — not mid-mint.
            return st === 'DONE' && !this.inflightAnalyze && !this.waitReport && !this.reportReady;
        },
        showPersonsLink() {
            const st = (this.status && this.status.status) || '';
            return st === 'DONE' && !this.inflightAnalyze && !this.waitReport && this.reportReady;
        },
        progressText() {
            const st = (this.status && this.status.status) || '';
            // Only PROC has a live worker; show percent only (no frame counters).
            if (st !== 'PROC') return '';
            const pct = this.percent_analys;
            if (pct === null || pct === undefined || pct === '') return '';
            const n = Number(pct);
            if (!Number.isFinite(n)) return '';
            return `${Math.round(n)}%`;
        },
    },
    methods: {
        reportPersonCount(report) {
            if (!report) return 0;
            // Lean list includes persons_count (membership) — prefer that.
            const lean = Number(report.persons_count);
            if (Number.isFinite(lean) && lean >= 0) {
                return lean;
            }
            if (Array.isArray(report.persons) && report.persons.length > 0) {
                return report.persons.length;
            }
            if (Array.isArray(report.person_uuids) && report.person_uuids.length > 0) {
                return report.person_uuids.length;
            }
            return 0;
        },
        settleReport(reportId, personsCount, { emptyConfirmed = false } = {}) {
            const id = Number(reportId);
            const n = Number(personsCount);
            this.personsnum_data = Number.isFinite(n) && n >= 0 ? n : 0;
            this.defreportlink_data = (Number.isFinite(id) && id > 0) ? `/reports/${id}` : '#';
            this.emptyReportConfirmed = !!emptyConfirmed && this.personsnum_data === 0;
            this.waitReport = false;
            this.reportPollTries = 0;
        },
        beginWaitReport(delayMs = 500) {
            // Never start mint-wait while reanalyze is still leaving DONE.
            if (this.inflightAnalyze) {
                return;
            }
            const st = (this.status && this.status.status) || '';
            if (st !== 'DONE') {
                return;
            }
            // Already showing a *populated* report — nothing to wait for.
            // Do NOT skip on stale lastreportid + "0 persons" (reanalyze race).
            if (this.reportReady && Number(this.personsnum_data) > 0) {
                this.waitReport = false;
                return;
            }
            this.waitReport = true;
            this.emptyReportConfirmed = false;
            this.reportPollTries = 0;
            // Clear stale "0 persons" / old link so UI spins while membership builds
            this.personsnum_data = '';
            this.defreportlink_data = '#';
            setTimeout(() => {
                this.getNewReport();
            }, delayMs);
        },
        getNewReport(){
            // Abandoned if we left DONE (reanalyze / STOP) mid-poll.
            if (this.inflightAnalyze) {
                this.waitReport = false;
                return;
            }
            const st = (this.status && this.status.status) || '';
            if (st !== 'DONE') {
                this.waitReport = false;
                return;
            }
            const url = `/reports/`;
            const params = {
                video_id: this.v_id,
                sort: 'id',
                sorttype: 'desc',
                // Lean list now carries persons_count; keep short for speed.
                short: 'y',
                perpage: 10
            }
            // ~60s of polling — membership often lands after DONE chrome/link exists
            const maxTries = 20;
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {
                if (this.inflightAnalyze || ((this.status && this.status.status) || '') !== 'DONE') {
                    this.waitReport = false;
                    return;
                }
                let payload = response.data;
                let reports = [];
                if (Array.isArray(payload)) {
                    reports = payload;
                } else if (payload && Array.isArray(payload.data)) {
                    reports = payload.data;
                } else if (payload && payload.id) {
                    reports = [payload];
                }
                const ready = reports.find(r => r && r.id && this.reportPersonCount(r) > 0);
                if (ready) {
                    this.settleReport(ready.id, this.reportPersonCount(ready));
                    return;
                }
                // Keep spinning on empty shells — do not flash "0 persons" mid-mint.
                const empty = reports.find(r => r && r.id);
                this.reportPollTries = (this.reportPollTries || 0) + 1;
                if (this.reportPollTries < maxTries) {
                    setTimeout(() => {
                        this.getNewReport();
                    }, 3000);
                    return;
                }
                // Timed out: durable empty report → "0 persons"; no row → No Report
                if (empty) {
                    this.settleReport(empty.id, 0, { emptyConfirmed: true });
                } else if (this.lastreportid) {
                    this.settleReport(this.lastreportid, 0, { emptyConfirmed: true });
                } else {
                    this.personsnum_data = 0;
                    this.defreportlink_data = '#';
                    this.emptyReportConfirmed = false;
                    this.waitReport = false;
                }

            }).catch( (error) => {
                console.log('error getNewReport(): ');
                console.log(error);
                if (this.inflightAnalyze || ((this.status && this.status.status) || '') !== 'DONE') {
                    this.waitReport = false;
                    return;
                }
                this.reportPollTries = (this.reportPollTries || 0) + 1;
                if (this.reportPollTries >= maxTries) {
                    const n = Number(this.personsnum);
                    if (Number.isFinite(n) && n > 0 && this.lastreportid) {
                        this.settleReport(this.lastreportid, n);
                    } else if (this.lastreportid) {
                        this.settleReport(this.lastreportid, 0, { emptyConfirmed: true });
                    } else {
                        this.waitReport = false;
                        this.emptyReportConfirmed = false;
                        this.personsnum_data = Number.isFinite(n) ? n : 0;
                        this.defreportlink_data = '#';
                    }
                    return;
                }
                setTimeout(() => {
                    this.getNewReport();
                }, 4000);
            });
        },
        testUpdate() {
            
            this.getNewReport();
            
            // console.log('this.status.id', this.status.id);
            
            // this.status.id = 4;
        
            // console.log('new this.status.id', this.status.id);
            // console.log('this.lastreportid', this.lastreportid);

            // this.update();
        },
        stPropByProp(propInName, propInVal, propOutName){
            let st = this.statuses.find(st => st[propInName] == propInVal),
                propOutVal = st!=undefined ? st[propOutName] : null;
            return propOutVal;            
        },
        changeStatus(statusId, count = 0){
            
            let data = {};
            // data.status_id = this.status.id;
            // this.status.id
            data.status_id = statusId;

            console.log('data.status_id from change status: ', data.status_id);

            // CONTINUE (2→WAIT): optimistic badge + start poll immediately.
            // Without this, UI stays WAIT forever while worker adopts PROC
            // (init only polls once for STOP/DONE and does not re-arm).
            if (statusId === 2 && count === 0) {
                const waitSt = this.statuses.find(st => st.status === 'WAIT' || st.id === 2);
                if (waitSt) {
                    this.status = waitSt;
                    this.update();
                }
            }

            
            axios.put( `/videos/${this.v_id}`,
                data,
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((response)=>{
                const sdkResponse = response.data.sdk_response;

                console.log('sdkResponse from send change status: ', response.data);


                if( sdkResponse != undefined && sdkResponse.status ){
                    let newStatus = this.statuses.find( st => st.status == sdkResponse.status.toUpperCase() );
                    if (newStatus) {
                        this.status = newStatus;
                        // Must re-arm poll (WAIT→PROC→DONE); previously only set local status
                        this.update();
                    } else {
                        this.getStatusSdk();
                    }
                } else {
                    if(count < 5){
                        console.log('count', count);
                        this.changeStatus(statusId, ++count);
                    } else {
                        this.getStatusSdk();
                    }
                }
            }).catch((e)=>{
                console.log('FAILURE!!');
                console.log(e);
                // Keep trying while UI thinks we are queued/processing
                if (this.status && (this.status.status === 'WAIT' || this.status.status === 'PROC')) {
                    setTimeout(() => { this.getStatusSdk(); }, 3000);
                }
            });            
        },        
        analizeSend(analizeType){
            
            console.log('analizeType from analizeSend: ', analizeType);

            // Drop stale report chrome so DONE→mint wait is fresh after REANALYZE
            this.waitReport = false;
            this.emptyReportConfirmed = false;
            this.personsnum_data = '';
            this.defreportlink_data = '#';
            this.reportPollTries = 0;
            // Block stale list/SDK DONE until the new wait/proc is observed.
            this.inflightAnalyze = true;
            this.inflightStaleDoneTries = 0;
            this.statusPollToken = (this.statusPollToken || 0) + 1;
            const pollToken = this.statusPollToken;

            // Optimistic WAIT so badge leaves DONE immediately (SDK truth follows via poll)
            const waitSt = this.statuses.find(st => st.status === 'WAIT' || st.id === 2);
            if (waitSt) {
                this.status = waitSt;
                this.update();
            }
            
            axios.post(`/videos/${analizeType}`,
                {video_id: this.v_id}
            ).then((response)=>{
                if (pollToken !== this.statusPollToken) return;
                let newStId = response.data && response.data.status_id;
                if (!newStId && response.data && response.data.data && response.data.data.status) {
                    const name = String(response.data.data.status).toUpperCase();
                    const obj = this.statuses.find(st => st.status === name);
                    if (obj) newStId = obj.id;
                }
                if (newStId) {
                    let newStObj = this.statuses.find(st => st.id == newStId);
                    if (newStObj) this.status = newStObj;
                }
                const stName = (this.status && this.status.status) || '';
                if (stName === 'WAIT' || stName === 'PROC') {
                    // Reanalyze landed — safe to clear inflight once poll confirms.
                } else if (stName === 'DONE') {
                    // Response still DONE somehow — keep inflight and force wait badge.
                    if (waitSt) this.status = waitSt;
                }
                // Always poll SDK — Laravel status is only a cache of SDK truth
                this.getStatusSdk(null, pollToken);
            }).catch((error)=>{
                console.log('FAILURE:');
                console.log(error);
                if (pollToken === this.statusPollToken) {
                    this.inflightAnalyze = false;
                }
            });            
        },       
        getStatusSdk(prevStatus = null, pollToken = null){
            const token = pollToken != null ? pollToken : this.statusPollToken;
            axios.post('/videos/getstatussdk',
                {video_id: this.v_id}
            ).then((response)=>{
                if (token !== this.statusPollToken) {
                    return;
                }
                if (!response.data || response.data.status == null || response.data.status === '') {
                    if (this.status && (this.status.status === 'WAIT' || this.status.status === 'PROC')) {
                        setTimeout(() => { this.getStatusSdk(null, token); }, 3000);
                    }
                    return;
                }
                
                let newStName = String(response.data.status).toUpperCase(),
                    oldStName = (this.status && this.status.status) || '';

                // Stale DONE while reanalyze is in flight — do not flash DONE+spinner.
                if (this.inflightAnalyze && newStName === 'DONE') {
                    this.inflightStaleDoneTries = (this.inflightStaleDoneTries || 0) + 1;
                    // ~15s of stale DONE → give up and show real SDK status (reanalyze may have failed).
                    if (this.inflightStaleDoneTries < 10) {
                        setTimeout(() => { this.getStatusSdk(null, token); }, 1500);
                        return;
                    }
                    this.inflightAnalyze = false;
                    this.inflightStaleDoneTries = 0;
                }
                if (this.inflightAnalyze && (newStName === 'WAIT' || newStName === 'PROC')) {
                    this.inflightAnalyze = false;
                    this.inflightStaleDoneTries = 0;
                    this.waitReport = false;
                }
                if (this.inflightAnalyze && (newStName === 'WRONG' || newStName === 'STOP')) {
                    this.inflightAnalyze = false;
                    this.inflightStaleDoneTries = 0;
                }

                if (response.data.percent_analys !== undefined) {
                    this.percent_analys = response.data.percent_analys;
                }
                if (response.data.processed_frames !== undefined) {
                    this.processed_frames = response.data.processed_frames;
                }
                if (response.data.count_frames !== undefined) {
                    this.count_frames = response.data.count_frames;
                }
                const desc = response.data.description || response.data.desc || '';
                if (desc) {
                    this.wrongReason = String(desc);
                } else if (newStName !== 'WRONG') {
                    this.wrongReason = '';
                }
                
                if(newStName != oldStName){
                    let newStObj = this.statuses.find(st => st.status == newStName);
                    if (newStObj) {
                        this.status = newStObj;
                        this.update();
                    }
                }

                if (desc) {
                    bus.$emit('updatevideoitem', {
                        'v_id': this.v_id,
                        'new_status': this.status,
                        'description': String(desc),
                    });
                }                
                if(newStName == 'WAIT' || newStName == 'PROC' ) {
                    setTimeout(() => {
                        this.getStatusSdk(null, token);
                    }, 3000);
                } 
                
                // Entering DONE: spin until report has real person count (or confirmed empty).
                // Stale lastreportid + "0 persons" must NOT skip the wait.
                if (newStName === 'DONE' && oldStName !== 'DONE' && !this.inflightAnalyze) {
                    const n = Number(this.personsnum_data);
                    if (!(this.reportReady && Number.isFinite(n) && n > 0)) {
                        this.beginWaitReport(1000);
                    }
                }

            }).catch((error)=>{
                console.log(error);
                // Transient errors must not kill the WAIT/PROC poll chain
                if (token !== this.statusPollToken) return;
                if (this.status && (this.status.status === 'WAIT' || this.status.status === 'PROC')) {
                    setTimeout(() => { this.getStatusSdk(null, token); }, 3000);
                }
            });

        },        
        init(){            
            if(
                this.status.status == 'PROC' || 
                this.status.status == 'WAIT'
            ){
                this.getStatusSdk();
            } else if (this.status.status == 'STOP') {
                // Reconcile STOP with SDK. DONE without a report is terminal
                // (deleted / none) — do not poll getstatussdk or it restarts waitReport.
                this.getStatusSdk();
            }
        },
        /** Top-right bulk ANALYZE: mirror per-row button action for this video. */
        onAnalyzeGroup(data) {
            if (data != this.v_id) return;
            const st = (this.status && this.status.status) || '';
            console.log('analyze_group', data, st);
            if (!st) {
                this.analizeSend('analize');
            } else if (st === 'DONE' || st === 'WRONG') {
                this.analizeSend('reanalize');
            } else if (st === 'STOP') {
                // Must go through /videos/analize (reanalyse + checkVideoDoneStatus),
                // not bare status_id=WAIT — otherwise SDK may finish with No report.
                this.analizeSend('analize');
            }
            // PROC / WAIT: already in flight — skip
        },
        update() {
                this.init();
                bus.$emit('updatevideoitem', 
                {
                    'v_id': this.v_id,
                    'new_status': this.status
                }
            );
        }
    },   
    watch: {
        status_prop(val) {
            if (val === undefined || val === null) return;
            const incoming = (val && val.status) || '';
            const prev = (this.status && this.status.status) || '';
            // Stale parent list refresh must not yank WAIT/PROC back to DONE mid-reanalyze
            // (that caused DONE badge + report spinner).
            if (this.inflightAnalyze || prev === 'WAIT' || prev === 'PROC') {
                if (incoming === 'DONE') {
                    return;
                }
                if (incoming === 'STOP' && (prev === 'WAIT' || prev === 'PROC')) {
                    return;
                }
            }
            this.status = val;
            this.init();
            if (val.status === 'DONE' && prev !== 'DONE' && !this.inflightAnalyze) {
                const n = Number(this.personsnum_data);
                if (!(this.reportReady && Number.isFinite(n) && n > 0)) {
                    this.beginWaitReport(1000);
                }
            }
        },
        description_prop(val) {
            if (val === undefined || val === null) return;
            this.wrongReason = String(val || '');
        },
        personsnum(val) {
            if (this.waitReport || this.inflightAnalyze) return;
            this.personsnum_data = val;
        },
        defreportlink(val) {
            if (this.waitReport || this.inflightAnalyze) return;
            this.defreportlink_data = val;
        },
    },
    mounted() {
        
        this.personsnum_data = this.personsnum;
        this.defreportlink_data = this.defreportlink;
        this.wrongReason = this.description_prop ? String(this.description_prop) : '';
        // Prefer durable report id from list payload when link was '#'
        if ((!this.defreportlink_data || this.defreportlink_data === '#') && this.lastreportid) {
            this.defreportlink_data = `/reports/${this.lastreportid}`;
        }
        // Normalize so Number(personsnum_data) is finite (prop may be undefined)
        if (this.personsnum_data === '' || this.personsnum_data === undefined || this.personsnum_data === null) {
            this.personsnum_data = 0;
        }

        this.status = this.status_prop!=undefined ? this.status_prop : {};
        // Page load with durable empty report (0 persons + link): allow "0 persons".
        // Without this flag, reportReady rejects n===0 and would show No Report wrongly.
        {
            const st = (this.status && this.status.status) || '';
            const n = Number(this.personsnum_data);
            const link = (this.defreportlink_data || '').trim();
            const hasLink = (link && link !== '#' && /\/reports\/\d+/.test(link))
                || !!this.lastreportid;
            if (st === 'DONE' && hasLink && Number.isFinite(n) && n === 0) {
                this.emptyReportConfirmed = true;
            }
        }
        this.init();
        // Once per instance — was wrongly re-bound inside init() on every poll
        bus.$on('analyze_group', this.onAnalyzeGroup);
        // Page load: DONE without report URL → show "No Report" immediately.
        // Do not beginWaitReport here — that spun forever after durable deletes.
        // Report wait is only started on WAIT/PROC → DONE transition.

    },
    beforeDestroy() {
        bus.$off('analyze_group', this.onAnalyzeGroup);
    }
}
</script>

<style lang="scss" scoped>
.status_and_info{
    min-width: 200px;
    display: flex;
    .statusvideo_text{
        min-width: 50px;
        text-align: center;
    }
}
.statusvideo{
    display: flex;
    align-items: center;
    .statusvideo_text{
        padding: 4px 8px;
        border-radius: 4px;
        color: var(--color-greylight);
        margin-right: 1rem;
        text-transform: uppercase;
        &.grey{
            background: #828282;
            color: #fff;
        }
        &.green{
            background: #219653;
            color: #fff;
        }
        &.blue{
            background: #3D9EFF;
            color: #fff;
        }
        &.red{
            background: #EB5757;
            color: #fff;
        }
    }

    .statusvideo_presons{
        margin-right: 1rem;
        display: flex;
        align-items: center;
        .statusvideo_presons_link{
            color: #fff;
        }
        .statusvideo_wrong_reason{
            max-width: 180px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: bottom;
            color: #eb5757;
            font-size: 11px;
            text-transform: none;
        }
        .statusvideo_no_report{
            color: #9e9e9e;
            font-size: 12px;
            text-transform: none;
            white-space: nowrap;
        }
        .statusvideo_report_spinner{
            display: inline-block;
            width: 1rem;
            height: 1rem;
            vertical-align: middle;
            border: 0.15em solid rgba(33, 150, 243, 0.25);
            border-right-color: #2196f3;
            border-radius: 50%;
            animation: statusvideo-spin 0.75s linear infinite;
        }
        @keyframes statusvideo-spin {
            to { transform: rotate(360deg); }
        }
        .statusvideo_presons_load{
            display: block;
            width: 22px;
            height: 22px;
            border: 2px solid var(--color-blue);
            border-radius: 30px;
        }
    }

}
</style>
